import React, { useContext } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const HomeScreen = ({ backgroundImage }) => {
  const { sendEvent } = useContext(DataLayerEventContext);

  return (
    <div className={styles.container}>
      <div className={styles.content} style={{ backgroundImage }}>
        <img
          src={getImageFromS3('images/sms-bond/logo.png')}
          alt="logo"
          className={styles.logo}
        />
        <div className={styles.packsContainer}>
          <div className={styles.packsImageContainer}>
            <img src={getImageFromS3('images/sms-bond/red-pack.png')} alt="red-pack" />
            <img src={getImageFromS3('images/sms-bond/blue-pack.png')} alt="blue-pack" />
          </div>
          <div className={styles.packsDescriptionContainer}>
            <div className={styles.packDescription}>
              <p>Bond Street<br /> Red</p>
              <div className={styles.price}>
                <p><b>130</b> грн*</p>
                <img src={getImageFromS3('images/sms-bond/price-button-bg.png')} alt="price-button" />
              </div>
            </div>
            <div className={styles.packDescription}>
              <p>Bond Street<br /> Blue</p>
              <div className={styles.price}>
                <p><b>130</b> грн*</p>
                <img src={getImageFromS3('images/sms-bond/price-button-bg.png')} alt="price-button" />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.packCharacteristicWrapper}>
          <div className={styles.packCharacteristic}>
            <span>9 мг</span>
            <span>вміст смол</span>
            <span>6 мг</span>
          </div>
          <div className={styles.packCharacteristic}>
            <span>0.7 мг</span>
            <span>вміст нікотину</span>
            <span>0.5 мг</span>
          </div>
        </div>
        <div className={styles.disclaimer}>
          *зазначено задекларовану максимальну роздрібну ціну з урахуванням акцизного податку на роздрібний продаж тютюнових виробів станом на вересень 2025 року
        </div>
        <div className={styles.characteristicContainer}>
          <div className={styles.characteristicItem}>
            <img src={getImageFromS3('images/sms-bond/format.png')} alt="format" />
            <p><b>20 сигарет</b> у форматі<br /> “Кінг Cайз” Cтандарт</p>
          </div>
          <div className={styles.characteristicItem}>
            <img src={getImageFromS3('images/sms-bond/filter.png')} alt="filter" />
            <p>Ущільнений<br /><b>ацетатний</b> фільтр</p>
          </div>
          <div className={styles.characteristicItem}>
            <img src={getImageFromS3('images/sms-bond/tobacco.png')} alt="tobacco" />
            <p>Бленд з <b>трьох сортів</b><br /> тютюну</p>
          </div>
        </div>
        <div className={styles.buyContainer}>
          <div className={styles.buyContent}>
            <p className={styles.buyTitle}>Де купити?</p>
            <p className={styles.buyDescription}><b>Bond Street Red</b> та <b>Blue</b> можна знайти у роздрібних точках продажу в твоєму місті або на офіційних онлайн сервісах, зокрема:</p>
            <div className={styles.buttonContainer}>
              <a
                href="https://rozetka.com.ua/ua/sigareti/c4638591/price=1300-1300;producer=bond/?utm_source=PMUsmsBond"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.buttonItem}
                onClick={() => sendEvent('rozetka')}
              >
                <p>Rozetka</p>
                <img src={getImageFromS3('images/sms-bond/glass.png')} alt="glass" />
              </a>
              <a
                href="https://cig-poshta.in.ua/shop/bond-street/?utm_source=CDAsmsBond"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.buttonItem}
                onClick={() => sendEvent('cig-poshta')}
              >
                <p>Cig-poshta</p>
                <img src={getImageFromS3('images/sms-bond/glass.png')} alt="glass" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає<br /> серйозні захворювання<br /> та залежність<br />
        Дана інформація про<br /> продукт надається<br /> відповідно<br />
        до статті 15 Закону<br /> України «Про захист<br /> прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) лист, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-bond">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
